<template>
    <div class="container mt-4" v-if="ordenesOrdenadas.length > 0">
      <!-- Tabla de Órdenes de Compra -->
      <table class="table table-hover shadow-sm">
        <thead class="table-secondary sticky-header">
          <tr>
            <th @click="ordenarPor('proveedor')" class="sortable-column">Proveedor</th>
            <th @click="ordenarPor('fecha_creacion')" class="sortable-column">Fecha de Creación</th>
            <th @click="ordenarPor('estado')" class="sortable-column">Estado</th>
            <th @click="ordenarPor('costo_inicial_estimado_usd')" class="sortable-column">Costo Inicial </th>
            <th @click="ordenarPor('costo_final_usd')" class="sortable-column">Costo Final </th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="orden in ordenesOrdenadas" :key="orden.id" 
            :class="{ 'clickable-row': true, 'selected-row': ordenSeleccionada?.id === orden.id }"
            @click="toggleDetalles(orden.id)"
          >
            <td>{{ orden.proveedor.nombre }}</td>
            <td>{{ new Date(orden.fecha_creacion).toLocaleDateString() }}</td>
            <td>
              <select v-model="orden.estado" @change="actualizarEstadoOrden(orden)" class="form-select form-select-sm">
                <option v-for="estado in estados" :key="estado" :value="estado">{{ estado }}</option>
              </select>
            </td>
            <td>{{ orden.costo_inicial_estimado_usd }}</td>
            <td>{{ orden.costo_final_usd }}</td>
            <td>
              <button class="btn btn-danger btn-sm" @click.stop="eliminarOrden(orden.id)">Eliminar</button>
            </td>
          </tr>
  
          <!-- Sección de detalles expandible -->
          <tr v-if="ordenSeleccionada">
            <td colspan="7">
              <div class="p-3 bg-light rounded">
                <h5>Detalles de la Orden #{{ ordenSeleccionada.id }}</h5>
                <ul>
                  <li v-for="item in ordenSeleccionada.items" :key="item.id">
                    {{ item.inventario_item.nombre }} - {{ item.cantidad }} unidades - Costo unitario: {{ item.costo_unitario_usd }} 
                  </li>
                </ul>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="container" v-else>
      <p>No hay órdenes de compra para mostrar.</p>
    </div>
  </template>

<script>
import axios from '@/axios';


export default {
  props: {
      // Propiedad para recibir el ID del proveedor seleccionado
      proveedor_id: {
          type: Number,
          required: false
      }
  },
  data() {
      return {
          ordenesCompra: [],
          ordenSeleccionada: null,
          ordenActiva: '',
          ordenAscendente: true,
          estados: [], // Lista de estados obtenida de la API
      };
  },
  computed: {
      ordenesOrdenadas() {
          return [...this.ordenesCompra].sort((a, b) => {
              let compare = 0;
              if (this.ordenActiva === 'estado') {
                  compare = a.estado.localeCompare(b.estado);
              } else if (typeof a[this.ordenActiva] === 'string') {
                  compare = a[this.ordenActiva].localeCompare(b[this.ordenActiva]);
              } else {
                  compare = a[this.ordenActiva] - b[this.ordenActiva];
              }
              return this.ordenAscendente ? compare : -compare;
          });
      }
  },
  methods: {
      async cargarOrdenesCompra() {
          try {
              const response = await axios.get('/api/ordenCompra/proveedor/'+this.proveedor_id);
              this.ordenesCompra = response.data;
          } catch (error) {
              console.error('Error al obtener las órdenes de compra:', error);
          }
      },
      async cargarEstados() {
          try {
              const response = await axios.get('/api/constantes/estados_orden_compra_inventario_items');
              this.estados = response.data;
          } catch (error) {
              console.error('Error al obtener los estados de las órdenes de compra:', error);
          }
      },
      ordenarPor(campo) {
          if (this.ordenActiva === campo) {
              this.ordenAscendente = !this.ordenAscendente;
          } else {
              this.ordenActiva = campo;
              this.ordenAscendente = true;
          }
      },
      async actualizarEstadoOrden(orden) {
          try {
              await axios.put(`/api/ordenCompra/estado/${orden.id}`, {
                  estado: orden.estado
              });
              alert('Estado de la orden actualizado con éxito.');
          } catch (error) {
              console.error('Error al actualizar el estado de la orden:', error);
              alert('Hubo un error al actualizar el estado. Intente nuevamente.');
          }
      },
      async toggleDetalles(id) {
          if (this.ordenSeleccionada && this.ordenSeleccionada.id === id) {
              this.ordenSeleccionada = null; // Ocultar detalles si ya están visibles
          } else {
              try {
                  const response = await axios.get(`/api/ordenCompra/${id}`);
                  this.ordenSeleccionada = response.data;
              } catch (error) {
                  console.error('Error al obtener los detalles de la orden:', error);
              }
          }
      },
      async eliminarOrden(id) {
          if (confirm('¿Estás seguro de eliminar esta orden de compra?')) {
              try {
                  await axios.delete(`/api/ordenCompra/${id}`);
                  this.cargarOrdenesCompra();
              } catch (error) {
                  console.error('Error al eliminar la orden de compra:', error);
              }
          }
      },
      redirectAltaOrdenCompra() {
          this.$router.push({ name: 'altaOrdenDeCompra' });
      }
  },
  mounted() {
      this.cargarOrdenesCompra();
      this.cargarEstados(); // Cargar los estados de las órdenes al montar el componente
  }
};
</script>






<style scoped>
.container {
  margin-top: 20px;
}

.table-hover tbody tr:hover {
  background-color: #f1f5f9;
}

.card {
  margin-top: 20px;
}

.btn {
  margin-right: 5px;
}

.sortable-column {
  cursor: pointer;
}

.sortable-column:hover {
  color: #495057;
}

.clickable-row {
  cursor: pointer;
}

.clickable-row:hover {
  background-color: #e9ecef;
}

tr.selected-row {
  background-color: #d4edda; /* Verde suave */
}

.sticky-header {
  position: sticky;
  top: 0;
  z-index: 1000;
  background-color: #dee2e6;
}

.table-secondary {
  background-color: #f8f9fa;
  color: #495057;
}

.btn-danger {
  background-color: #dc3545;
  border-color: #dc3545;
}

.bg-light {
  background-color: #f8f9fa !important;
}

h5 {
  color: #343a40;
}
</style>